import React from 'react';

var _path;

var SvgSearchMinor = function SvgSearchMinor(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", Object.assign({
      viewBox: "0 0 20 20"
    }, props), _path || (_path =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm9.707 4.293-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414z"
    })))
  );
};

export { SvgSearchMinor as S };